// components/common/EditModal.js
import { useState } from 'react';
import styles from './PasswordEditModal.module.css';
import axios from "../../../../utils/api/axios";
import { DialogEnum, showDialog } from '../../../../utils/dialog/Dialog';
import EditModal from './EditModal';
import { IAM_SERVER_UNIFIEDPROFILE } from '../../../../utils/Config';
import components from '../../../../resources/styles/components.module.css';
import { getCookie } from '../../../../utils/cookies/cookies';
import { InnocodeButton, InnocodeInput } from '@intsoft/innocode-core';

function PasswordEditModal({ onClose, onSuccess }) {
  const [step, setStep] = useState("change");
  const [currentPw, setCurrentPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");

  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [pwValidations, setPwValidations] = useState({
    hasEnglish: false,
    hasNumber: false,
    hasLength: false,
    isMatch: false,
  });

  const checkPasswordValidation = (pw, confirmPw) => {
    setPwValidations({
      hasEnglish: /[a-zA-Z]/.test(pw),
      hasNumber: /[0-9]/.test(pw),
      hasLength: pw.length >= 8 && pw.length <= 20,
      isMatch: pw === confirmPw && confirmPw.length > 0,
    });
  };

  // 비밀번호 표시 상태 추가
  const [showPassword, setShowPassword] = useState(false);

  const verifyPassword = () => {
    const userId = getCookie("user_id");

    axios.post(`${IAM_SERVER_UNIFIEDPROFILE}/verify/password`, {
      password: currentPw,
      unifiedProfileId: userId
    })
    .then((res) => {
      const data = res.data;

      if (data.code === 200 || data.success === true) {
        setStep("change");
      } else {
        showDialog(DialogEnum.DEFAULT, "실패", data.resultMessage || "현재 비밀번호가 일치하지 않습니다.");
      }
    })
    .catch((err) => {
      showDialog(DialogEnum.DEFAULT, "오류", "서버 오류가 발생했습니다.");
    });

  };


  const savePassword = () => {
    const userId = getCookie("user_id");

    // 비밀번호 형식 검사
    if (!isNextButtonEnabled) {
      showDialog(DialogEnum.DEFAULT, "오류", "비밀번호 형식을 확인하세요.");
      return;
    }

    if (newPw !== confirmPw) {
        showDialog(DialogEnum.DEFAULT, "오류", "비밀번호가 일치하지 않습니다.");
        return;
    }

    axios.post(`${IAM_SERVER_UNIFIEDPROFILE}/update`, {
        unifiedProfileId: userId,
        password: newPw
      }).then(() => {
        showDialog(DialogEnum.SUCCESS, "성공", "비밀번호가 변경되었습니다.", onClose);
      }).catch(() => {
        showDialog(DialogEnum.DEFAULT, "실패", "비밀번호 변경 실패");
      });
  };

   const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setNewPw(newPassword);
    checkPasswordValidation(newPassword, confirmPw);
  };

  const handleConfirmPasswordChange = (e) => {
    const newConfirmPassword = e.target.value;
    setConfirmPw(newConfirmPassword);
    checkPasswordValidation(newPw, newConfirmPassword);
  };
  

    // 비밀번호 가시성 토글 함수
  const handlePasswordToggle = () => {
    setShowNewPassword(!showNewPassword);
  };

  // 비밀번호 확인 가시성 토글 함수
  const handleConfirmPasswordToggle = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const isNextButtonEnabled = Object.values(pwValidations).every(Boolean);

  return (
    <div className={styles.layer__popWrap}>
      <div className={`${styles.layer__popCont} ${styles.user}`}>
        <div className={`${styles.layer__popHeader} ${styles.detail}`}>                 {/* 모달 헤더 */}
          <h1 className={`innocode-typography--headline-md innocode-typography--bold ${styles.contentAreaTitleText}`}>
            비밀번호 변경
          </h1>
          <InnocodeButton
              theme={"opacity"}
              designType='assistive'
              enablePadding={false}
              iconOnly={true}
              icon={<svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18 17.94 6M18 18 6.06 6" />
              </svg>
              }
              onClick={onClose}
          /> 
        </div>
        <div className={styles.layer__popDetail}>   
          <>
            {step === "verify" && (
              <>
                <div className={styles.verifyFormContainer}> {/* 구글 스타일 폼 컨테이너 */}
                  <h3 className={styles.verifyTitle}>계속하려면 먼저 본인임을 인증하세요.</h3>
                  <div className={styles.passwordInputGroup}>
                    <label htmlFor="current-password" className={styles.passwordLabel}>비밀번호 입력</label>
                    <input
                      id="current-password"
                      className={styles.passwordInputField}
                      type={showPassword ? "text" : "password"}
                      value={currentPw}
                      onChange={(e) => setCurrentPw(e.target.value)}
                      aria-label="현재 비밀번호 입력"
                    />
                  </div>
                  <div className={styles.showPasswordContainer}>
                    <input
                      type="checkbox"
                      id="show-password"
                      className={styles.showPasswordCheckbox}
                      checked={showPassword}
                      onChange={() => setShowPassword(!showPassword)}
                    />
                    <label htmlFor="show-password" className={styles.showPasswordLabel}>비밀번호 표시</label>
                  </div>
                  <div className={styles.verifyButtonRow}>
                    <InnocodeButton
                      size="md"
                      designType="primary" 
                      fullWidth={true}
                      className={styles.nextButton}
                      onClick={verifyPassword}
                    >다음</InnocodeButton>
                    {/* <button className={styles.nextButton} onClick={verifyPassword}>다음</button> */}
                  </div>
                </div>
              </>
            )}

            {step === "change" && (
              <>
                <div className={styles.passwordInputGroup}>
                  <label htmlFor="new-password" className={styles.passwordLabel}>새 비밀번호</label>
                  <div className={components.innocode_input_wrapper}>
                    {/* <input
                      id="new-password"
                      className={`${components.innocode_input} ${components.innocode_input_md}`}
                      type={showNewPassword ? 'text' : 'password'}
                      value={newPw}
                      onChange={handlePasswordChange}
                      aria-label="새 비밀번호"
                    /> */}
                    <InnocodeInput
                      type={showNewPassword ? 'text' : 'password'}
                      value={newPw}
                      onChange={handlePasswordChange}
                      showTrailingContent={true}
                      trailingContent={showNewPassword ? <svg className={styles.password_icon} onClick={handlePasswordToggle} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.933 13.909A4.357 4.357 0 0 1 3 12c0-1 4-6 9-6m7.6 3.8A5.068 5.068 0 0 1 21 12c0 1-3 6-9 6-.314 0-.62-.014-.918-.04M5 19 19 5m-4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                      </svg>
                      : <svg onClick={handlePasswordToggle}  className={styles.password_icon} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" strokeWidth="2" d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z"/>
                        <path stroke="currentColor" strokeWidth="2" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                      </svg>
                    }
                    />  
                    {/* <span
                      className={`material-symbols-outlined ${components.innocode_input_icon_right}`}
                      onClick={handlePasswordToggle} // onClick 이벤트 핸들러 추가
                    >
                      
                    </span> */}
                    
                  </div>

                  <div className={styles.password_check_list}>
                    <div className={`${styles.password_check_item} ${pwValidations.hasEnglish ? styles.valid : ''}`}>
                      <span className={`material-symbols-outlined ${styles.password_icon}`}>check</span>
                      <div className={styles.password_check_item_text}>영문포함</div>
                    </div>
                    <div className={`${styles.password_check_item} ${pwValidations.hasNumber ? styles.valid : ''}`}>
                      <span className={`material-symbols-outlined ${styles.password_icon}`}>check</span>
                      <div className={styles.password_check_item_text}>숫자포함</div>
                    </div>
                    <div className={`${styles.password_check_item} ${pwValidations.hasLength ? styles.valid : ''}`}>
                      <span className={`material-symbols-outlined ${styles.password_icon}`}>check</span>
                      <div className={styles.password_check_item_text}>8-20자 이내</div>
                    </div>
                  </div>
                </div>

                <div className={styles.passwordInputGroup}>
                  <label htmlFor="new-password-confirm" className={styles.passwordLabel}>새 비밀번호 확인</label>
                  <div className={components.innocode_input_wrapper}>
                    {/* <input
                      id="new-password-confirm"
                      className={`${components.innocode_input} ${components.innocode_input_md}`}
                      type={showConfirmPassword ? 'text' : 'password'}
                      value={confirmPw}
                      onChange={handleConfirmPasswordChange}
                      aria-label="새 비밀번호 확인"
                    />
                    <span
                      className={`material-symbols-outlined ${components.innocode_input_icon_right}`}
                      onClick={handleConfirmPasswordToggle} // onClick 이벤트 핸들러 추가
                    >
                      {showConfirmPassword ? 'visibility_off' : 'visibility'}
                    </span> */}

                    <InnocodeInput
                      type={showConfirmPassword ? 'text' : 'password'}
                      value={confirmPw}
                      onChange={handleConfirmPasswordChange}
                      showTrailingContent={true}
                      trailingContent={showConfirmPassword ? <svg className={styles.password_icon} onClick={handleConfirmPasswordToggle} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.933 13.909A4.357 4.357 0 0 1 3 12c0-1 4-6 9-6m7.6 3.8A5.068 5.068 0 0 1 21 12c0 1-3 6-9 6-.314 0-.62-.014-.918-.04M5 19 19 5m-4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                      </svg>
                      : <svg onClick={handleConfirmPasswordToggle}  className={styles.password_icon} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" strokeWidth="2" d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z"/>
                        <path stroke="currentColor" strokeWidth="2" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                      </svg>
                    }
                    />  
                  </div>
                  <div className={styles.password_check_list}>
                    <div className={`${styles.password_check_item} ${pwValidations.isMatch ? styles.valid : styles.invalid}`}>
                      <span className={`material-symbols-outlined ${styles.password_icon}`}>check</span>
                      <div className={styles.password_check_item_text}>비밀번호 일치</div>
                    </div>
                  </div>
                </div>
                <div className={styles.modalButtonRow}>
                  {/* <button 
                  type="button"
                   className={`${components.btn} ${components.btn_solid} ${components.btn_primary} ${components.btn_lg} ${styles.submit_btn}`}
                    disabled={!isNextButtonEnabled}
                    onClick={savePassword}>
                      저장
                  </button> */}
                  <InnocodeButton
                    size="md"
                    designType="primary" 
                    fullWidth={true}
                    className={styles.submit_btn}
                    disabled={!isNextButtonEnabled}
                    onClick={savePassword}
                  >
                    저장
                  </InnocodeButton>
                </div>
              </>
            )}
          </>

        </div>
      </div>
    </div>
  );
}

export default PasswordEditModal;